import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { PermissionCard, SubPermissionCard } from '../cards';

export interface ReportAccessBlockProps {
  id: string;
  label: string;
  description: string;
  enabled: boolean;
  onEnabledChange: (value: boolean) => void;
  viewLabel: string;
  viewDescription: string;
  viewAccess: string;
  onViewAccessChange: (value: string) => void;
  exportDescription: string;
  allowExport: boolean;
  onAllowExportChange: (value: boolean) => void;
}

export const ReportAccessBlock: React.FC<ReportAccessBlockProps> = ({
  id,
  label,
  description,
  enabled,
  onEnabledChange,
  viewLabel,
  viewDescription,
  viewAccess,
  onViewAccessChange,
  exportDescription,
  allowExport,
  onAllowExportChange,
}) => (
  <div className="flex flex-col gap-2">
    <PermissionCard
      label={<Label htmlFor={id} className="cursor-pointer">{label}</Label>}
      description={description}
      onToggle={() => onEnabledChange(!enabled)}
      control={
        <Checkbox
          id={id}
          checked={enabled}
          onCheckedChange={(c) => onEnabledChange(c as boolean)}
        />
      }
    />
    {enabled && (
      <div className="flex flex-col gap-2">
        <SubPermissionCard
          label={viewLabel}
          description={viewDescription}
          control={
            <Select value={viewAccess} onValueChange={onViewAccessChange}>
              <SelectTrigger className="w-44"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="own">Own Only</SelectItem>
                <SelectItem value="team">Team (department)</SelectItem>
                <SelectItem value="all">All</SelectItem>
              </SelectContent>
            </Select>
          }
        />
        <SubPermissionCard
          label="Allow Export"
          description={exportDescription}
          onToggle={() => onAllowExportChange(!allowExport)}
          control={<Checkbox checked={allowExport} onCheckedChange={(c) => onAllowExportChange(c as boolean)} />}
        />
      </div>
    )}
  </div>
);
